import { render, staticRenderFns } from "./DeviceUseTableView.vue?vue&type=template&id=197f8a13&scoped=true"
import script from "./DeviceUseTableView.vue?vue&type=script&lang=js"
export * from "./DeviceUseTableView.vue?vue&type=script&lang=js"
import style0 from "./DeviceUseTableView.vue?vue&type=style&index=0&id=197f8a13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197f8a13",
  null
  
)

export default component.exports